import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { InlineInputGroup, Input } from 'barnyard/components';


const InlineItemSelect = (props) => {
  const {
    label,
    description,
    ...other
  } = props;

  return (
    <InlineInputGroup
      label={label}
      description={description}
      InputComponent={Input}
      placeholder='123,456,789'
      {...other}
    />
  );
};

InlineItemSelect.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
};

InlineItemSelect.defaultProps = {
  label: 'Vetcove Item IDs',
  description: 'List of comma separated item ids'
};

export default memo(InlineItemSelect);
